import { render, staticRenderFns } from "./DateSelectionView.vue?vue&type=template&id=96356df8"
import script from "./DateSelectionView.vue?vue&type=script&lang=ts"
export * from "./DateSelectionView.vue?vue&type=script&lang=ts"
import style0 from "./DateSelectionView.vue?vue&type=style&index=0&id=96356df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports